import React from "react";
import PropTypes from "prop-types";

import * as types from "../../../constants/ComponentConstants";

import Form from "../../common/Form";
import Section from "../../common/Section";
import Row from "../../common/Row";
import Fieldset from "../../common/Fieldset";
import SporttakkenComponent from "./parts/SporttakkenComponent";
import Table from "../../common/Table";

function getHeaders(level) {
    const headers = ["Sporttak", "Discipline", "Sub-discipline"];
    let tableHeaders = [];

    for (let i = 0; i <= level; i++) {
        if (i < 3) {
            tableHeaders.push(headers[i]);
        }
        else if (i === 3) {
            tableHeaders.splice(i - 1, 1);
            tableHeaders.push(headers[2] + ' ' + (i - 2).toString());
            tableHeaders.push(headers[2] + ' ' + (i - 1).toString());
        }
        else if (i > 3) {
            tableHeaders.push(headers[2] + ' ' + (i - 1).toString());
        }
    }

    return tableHeaders;
}

const SporttakkenOverzichtForm = (props) => {
    const {
        models,
        onChange,
        onSave,
        disabled,
        onUndo,
        undoButtonDisabled,
        checkedSporttakken,
        onIncreaseLevel,
        level,
        onAdd,
        indeterminateSporttakken
    } = props;

    let sporttakkenForComponent = models;

    return (
        <Section title="Sporttakken" color={types.COLOR_GREEN}>
            <Form name="sporttakken"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Bewaar"
                onRightButtonClick={onSave}
                rightButtonDisabled={disabled}
                leftButtonLabel="Voeg toe"
                onLeftButtonClick={onAdd}
                leftButtonDisabled={disabled}
                onUndoButtonClick={onUndo}
                undoButtonVisible={!undoButtonDisabled}
            >
                <Fieldset>
                    <Row>
                        {sporttakkenForComponent && sporttakkenForComponent.length ?
                            <Table
                                id="SporttakkenTable"
                                style={{ 'border': '1px', 'borderStyle': 'solid', 'borderColor': '#eeefef', 'frame': 'void', 'rules': 'rows' }}
                                headers={getHeaders(level)}
                            >
                                <SporttakkenComponent
                                    indeterminateSporttakken={indeterminateSporttakken}
                                    sporttakken={sporttakkenForComponent}
                                    checkedSporttakken={checkedSporttakken}
                                    onChange={onChange}
                                    onIncreaseLevel={onIncreaseLevel}
                                    maxLevel={level}
                                    disabled={disabled} />
                            </Table>
                            :
                            null
                        }
                    </Row>
                </Fieldset>
            </Form>
        </Section>
    );
};

SporttakkenOverzichtForm.propTypes = {
    models: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    onUndo: PropTypes.func,
    undoButtonDisabled: PropTypes.bool,
    checkedSporttakken: PropTypes.array,
    onIncreaseLevel: PropTypes.func,
    level: PropTypes.number,
    onAdd: PropTypes.func.isRequired,
    indeterminateSporttakken: PropTypes.array
};

export default SporttakkenOverzichtForm;